import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CalculatorIndexComponent} from "./calculator-index/calculator-index.component";


const routes: Routes = [
  {path: '', component: CalculatorIndexComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
